import React, { useEffect } from 'react';
import ActivitiesHero from '../components/ActivitiesHero';
import ActivitiesList from '../components/ActivitiesList';
import '../styles/Activities.css';

function Activities() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="activities-page">
      <ActivitiesHero />
      <ActivitiesList />
    </main>
  );
}

export default Activities;
